<template>
    <v-row v-if="!$store.getters.progress" class="ma-0">
        <v-col cols="12" class="pa-0">
			<v-card class="pa-0 round-card background-2">
				<v-card-title class="pa-2">
					<div>
						<p class="pl-2 pl-xl-3">{{ title }}</p>
					</div>				
					<div>
						<p v-if="entityTitle" class="entity-title">&nbsp;&nbsp;{{ entityTitle }}</p>
					</div>
				<v-spacer></v-spacer>
				<v-tooltip v-if="!showTable" top>
					<template v-slot:activator="{ on }">							
						<v-btn @click="showTable = !showTable" v-on="on" icon :style="listButtonStyle">
							<v-icon>storage</v-icon>
						</v-btn>
					</template>
					<span>Visualizza Tabella</span>
				</v-tooltip>
				<v-tooltip v-else top>
					<template v-slot:activator="{ on }">							
						<v-btn @click="showTable = !showTable" v-on="on" icon :style="listButtonStyle">
							<v-icon>equalizer</v-icon>
						</v-btn>
					</template>
					<span>Visualizza Grafico</span>
				</v-tooltip>
				<v-tooltip top v-if="showTable">
					<template v-slot:activator="{ on }">							
						<v-btn @click="$eventBusUtility.exportCSV(tableHeaders, chartData.data, 'Fatturato')" v-on="on" icon>
							<v-icon>get_app</v-icon>
						</v-btn>
					</template>
					<span>Download</span>
				</v-tooltip>
				</v-card-title>
				<v-divider></v-divider>
				
				<v-container class="pt-4" fluid>
					<fields-generator
						v-if="loaded"
						class="pt-4"
						:fieldsset.sync="infoData"
						:model="model"
						ref="fieldsgenerator"
					></fields-generator>
					<v-row class="ma-0 px-2 pb-2" v-if="!showTable">
						<v-col class="py-0" cols="6" sm="6" md="2" lg="2" >
							<v-switch 
								inset
								label="Mostra totali"
								color="primary"
								v-model="showTotal"
								hide-details
								class="margin-auto"
							></v-switch>
						</v-col>
					</v-row>
					<v-row>
						<v-divider></v-divider>
					</v-row>
					<v-row v-show="showTable && loaded">
						<v-data-table class="background-2 w100p"
							:items="chartData.data"
							:headers="tableHeaders"
							hide-default-footer
							disable-pagination
							fixed-header
							:mobile-breakpoint="0">
							<template v-slot:item="{ item }">
								<tr class="cursor-pointer">
									<template v-for="(header, h) in tableHeaders">
										<td v-if="header.calc" class="text-left" :key="h" v-html="calcPercentage(item, h)">
										</td>
										<td v-else-if="header.value == 'month'" :key="h">
											{{ item[header.value] }}
										</td>
										<td v-else :key="h">
											{{ item[header.value] | currency }}
										</td>
									</template>
								</tr>
							</template>
							<template v-slot:body.append>
								<tr>
									<td v-for="(header, h) in tableHeaders" :key="h">
										<strong class="fs14i" v-if="h == 0">Totale</strong>
										<strong class="fs14i" v-else-if="header.calc" v-html="calcTotalPercentage(header, h)"></strong>
										<strong class="fs14i" v-else>{{ calcTotal(header.value) | currency }}</strong>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-row>

					<v-row v-show="!showTable && loaded" >
						<v-col cols="12">
							<line-chart
								:chart-data="chartData"
								:show-total="showTotal"
								:title="title"
							></line-chart>
						</v-col>
					</v-row>
					<v-col id="exportbutton2" v-show="!showTable"></v-col>
				</v-container>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import Vue from 'vue'
import LineChart from '@/components/common/LineChart'

export default {
	name: 'revenue-chart',
	components: {
		LineChart,
	},

	props: {
		modelDef: String,
		url: String,
		modelId: Number,
		modelKey: String,
		title: {
			type: String,
			default: 'Fatturato'
		},
		entityTitle: String,
		comparisonType: {
			type: String,
			default: 'percentage',
			validator: v => ['percentage', 'difference', 'none'].includes(v)
		},
		comparisonLabel: {
			type: String,
			default: ''
		},
	},

	data() {
		return {
			fieldsset: {},
			model: this.modelKey ? { [this.modelKey]: this.modelId } : {},
			infoData: {},
			loaded: false,
			chartData: {
				series: [],
				data: []
			},
			showTotal: false,
			showTable: true,
			listButtonStyle: '',
			datepicker_menu: {},
			totalItems: 0,
			tableHeaders: []
		}
	},

	computed: {
	},
		
	created() {
		this.axios.post(this.url + '-info', this.model).then(response => {
			// get body data
			this.infoData = response.data.info
			this.fieldsset = response.data.info.fields
			this.chartData.labels = response.data.info.labels

			_.forEach(this.fieldsset, (value, key) => {
				if(value.default) {
					Vue.set(this.model, value.key, value.default)
				}
			})
			this.loaded = true

		}, response => {
			// error callback
		})
	},

	watch: {
		model: {
			handler() {
				this.getData()
			},
			deep: true,
		},

		showTable: {
			handler(newVal, oldVal) {
				if(newVal) {
					this.listButtonStyle = ''
				} else this.listButtonStyle = 'margin-right: 54px !important;'
			}
		}
	},

	methods: {

		getData() {
			const colors = ['rgb(0,103,187)','rgb(242,36,100)','rgb(160,44,172)','rgb(0,149,239)','rgb(61,82,176)','rgb(104,61,178)']

			this.axios.post(this.url, this.model).then(response => {
				this.chartData.series = []
				this.chartData.data = []
				this.tableHeaders = [
					{
						'text': 'Mesi',
						'value': 'month',
						'sortable': false
					},
				]

				let colorIndex = 0
				_.forEach(response.data.data.datasets, (value, key) => {
					this.tableHeaders.push({
						'text': value.label,
						'value': value.label
					})
					if(this.comparisonType !== 'none' && response.data.data.datasets[key + 1]) {
						const nextLabel = response.data.data.datasets[key + 1].label
						const defaultText = this.comparisonType === 'difference'
							? value.label + ' - ' + nextLabel
							: value.label + ' - ' + nextLabel + ' %'
						this.tableHeaders.push({
							'text': this.comparisonLabel || defaultText,
							'value': value.label,
							'calc': value.label
						})
					}

					this.chartData.series.push({
						name: value.label.toString(),
						valueField: value.label.toString(),
						color: colors[colorIndex % colors.length]
					})
					colorIndex++

					_.forEach(value.data, (val, k) => {
						if(!this.chartData.data[k]) {
							this.chartData.data[k] = {
								month: this.capitalizeFirstLetter(moment.months(k)),
								[value.label]: val
							}
						} else {
							this.chartData.data[k][value.label] = val
						}
					})
				})

				this.loaded = true
				this.showTotal = false

			}, response => {
				// error callback
			})
		},

		calcTotal(year) {
			return this.chartData.data.reduce((acc, data) => acc + parseFloat(data[year]), 0)
		},

		calcPercentage(item, h) {
			const a = parseFloat(item[this.tableHeaders[h].value]) || 0
			const b = parseFloat(item[this.tableHeaders[h+1].value]) || 0
			if (this.comparisonType === 'difference') {
				return this.renderDifference(a - b)
			}
			if(parseInt(a) == parseInt(b)) {
				return '<td class="text-center"><span><i aria-hidden="true" class="v-icon material-icons theme--light info--text">trending_flat</i></span></td>'
			} else if(parseInt(b) == 0) {
				return '<span class="error--text">-100 %<i aria-hidden="true" class="v-icon material-icons theme--light error--text">trending_down</i></span>'
			} else if(parseInt(a) == 0) {
				return '<span class="success--text"><i aria-hidden="true" class="v-icon material-icons theme--light success--text">trending_up</i></span>'
			}
			let result = (Math.round(((b - a) * 100) / a * 100) / 100)
			if(result > 0) {
				return '<span class="success--text">' + result + ' <i aria-hidden="true" class="v-icon material-icons theme--light success--text">trending_up</i></span>'
			} else {
				return '<span class="error--text">' + result + ' <i aria-hidden="true" class="v-icon material-icons theme--light error--text">trending_down</i></span>'
			}
		},

		calcTotalPercentage(header, h) {
			const a = this.calcTotal(this.tableHeaders[h].value)
			const b = this.calcTotal(this.tableHeaders[h+1].value)
			if (this.comparisonType === 'difference') {
				return this.renderDifference(a - b)
			}
			if(a == b) {
				return '<td class="text-center"><span><i aria-hidden="true" class="v-icon material-icons theme--light info--text">trending_flat</i></span></td>'
			} else if(b == 0) {
				return '<span class="error--text">-100 %<i aria-hidden="true" class="v-icon material-icons theme--light error--text">trending_down</i></span>'
			} else if(a == 0) {
				return '<span class="success--text"><i aria-hidden="true" class="v-icon material-icons theme--light success--text">trending_up</i></span>'
			}
			let result = (Math.round(((b - a) * 100) / a * 100) / 100)
			if(result > 0) {
				return '<span class="success--text">' + result + ' <i aria-hidden="true" class="v-icon material-icons theme--light success--text">trending_up</i></span>'
			} else {
				return '<span class="error--text">' + result + ' <i aria-hidden="true" class="v-icon material-icons theme--light error--text">trending_down</i></span>'
			}
		},

		renderDifference(diff) {
			const formatted = this.$options.filters.currency(Math.abs(diff))
			if (Math.abs(diff) < 0.005) {
				return '<span><i aria-hidden="true" class="v-icon material-icons theme--light info--text">trending_flat</i></span>'
			}
			if (diff > 0) {
				return '<span class="success--text">+' + formatted + ' <i aria-hidden="true" class="v-icon material-icons theme--light success--text">trending_up</i></span>'
			}
			return '<span class="error--text">-' + formatted + ' <i aria-hidden="true" class="v-icon material-icons theme--light error--text">trending_down</i></span>'
		},

		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1)
		}
	},
}
</script>